

import { Component, Vue } from 'vue-property-decorator'
import TermsPop1 from '../../biz-kr/member/TermsPop1.vue';
import TermsPop2 from '../../biz-kr/member/TermsPop2.vue';

@Component({
  components: {TermsPop1, TermsPop2}
})
export default class Introduction extends Vue{
  showTerms1 = false;
  showTerms2 = false;
}
